import { http, authHeader } from '@/http-commons';

class AbonoDeduccionDataService {
    tableByDeduccion( deduccionId, params ){
        return http.get(`api/v1/abonoDeduccion/tableByIdDeduccion/${deduccionId}`, { params, headers : authHeader() });
    }
    createDirect( abono ){
        return http.post('api/v1/abonoDeduccion/createDirect', abono, { headers : authHeader() });
    }
    show( id ){
        return http.get(`api/v1/abonoDeduccion/get/${id}`, { headers : authHeader() });
    }
    cancel( id, catCancellationReasonId ){
        return http.delete(`api/v1/abonoDeduccion/cancel/${id}`, { params: { catCancellationReasonId }, headers : authHeader() });
    }
    findByDeduccionAndCashRegister( idDeduccion, cashRegisterId ){
        return http.get('api/v1/abonoDeduccion/byDeduccionAndCashRegister', { params: { idDeduccion, cashRegisterId }, headers : authHeader() });
    }
    findByCashRegister( cashRegisterId ){
        return http.get(`api/v1/abonoDeduccion/findByCashRegister/${cashRegisterId}`, { headers : authHeader() });
    }
}
export default new AbonoDeduccionDataService();